import { Component, HostListener, Input, OnInit } from '@angular/core';
import { switchMap, tap } from 'rxjs';
import { AnchorModel, DocentiPub, Subtree } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { NodeService } from 'src/app/shared/services/node.services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-persona',
  templateUrl: './page-persona.component.html',
  styleUrls: ['./page-persona.component.scss']
})
export class PagePersonaComponent implements OnInit {

  @Input() node: any;
  @Input() anchorItems: AnchorModel[] = [];
  @Input() levelMenu: Subtree[] = [];
  @Input() isSecondLevelUp: boolean = false;
  public idAnchor: string = '';
  public block: any;
  public imgPath = "";
  public isSpinner: boolean = false;
  public domainWebsite = environment.urlApi;
  public titlePage: string = '';
  public isCollapseHeader: boolean = false;
  public isShowLocalMenu: any;
  public dataFieldTaxonomies: any[] = [];
  public pubblicazioniFirst: DocentiPub[] = [];
  public pubblicazioniOther: DocentiPub[] = [];
  public isOtherPub: boolean = false;
  public keywords: any[] = [];
  public classColumn: string = '';
  //MODALE SHARE
  public onHoverShare: boolean = false;

  constructor(
    private helpersService: HelpersService,
    public nodeService: NodeService
  ) { }

  ngOnInit(): void {
    this.initComponent();
  }

  @HostListener('document:scroll', ['$event'])
  public onViewportScroll() {
    let boundingCollapse;
    if (this.isSpinner && this.node) {
      boundingCollapse = document.querySelector('.container-field-taxonomies')?.getBoundingClientRect();
    }
    if ((boundingCollapse && boundingCollapse.y < -40 && boundingCollapse.width > 767) || (boundingCollapse && boundingCollapse.y < -200 && boundingCollapse.width <= 767)) {
      this.isCollapseHeader = true;
    } else {
      this.isCollapseHeader = false;
    }
  }

  private initComponent(): void {
    this.nodeService.getRowTypeView(this.node.langcode[0].value, this.node.field_oggetto_view[0].value, this.node.field_tipo_view[0].value, this.node.preview, this.node.nid[0].value).pipe(
      tap(resView => {
        this.block = resView[0];
        this.setDataFields(this.block);
        this.imgPath = this.block.field_immagine ? this.domainWebsite + this.helpersService.retrieveImage(this.block.field_immagine, "src") : '';
        this.classColumn = this.setColumnContact(this.block);
      }),
      switchMap(block => this.nodeService.getPersonaRicercaScientifica(this.node.langcode[0].value, block[0].field_id_ricerca_scientifica))
    ).subscribe((persona: any) => {
      let pubblicazioni: DocentiPub[] = this.node.field_id_ricerca_scientifica[0].value && this.node.field_recupera_informazioni_da_r[0].value ? persona.publications : [];
      if (pubblicazioni && pubblicazioni.length) {
        pubblicazioni.forEach((pub, idx) => {
          if (idx < 6) {
            this.pubblicazioniFirst.push(pub);
          } else {
            this.pubblicazioniOther.push(pub);
          }
        });
      }
    });
    this.isSpinner = true;
    this.helpersService.showLocalMenuBS.subscribe(value => {
      this.isShowLocalMenu = value;
    });
    if (this.node.field_tassonomia_keyword_tematic) {
      this.keywords = this.getTassonomiaBlock(this.node.field_tassonomia_keyword_tematic);
    }
  }

  addNewAnchorItem(value: AnchorModel) {
    if (value.labelRow !== '') {
      this.anchorItems.push(value);
    }
    this.anchorItems.sort((a, b) => a.position - b.position);
    // this.idAnchor = this.anchorItems[0].idRow;
  }

  public openMenu(): void {
    this.helpersService.openLocalMenuBS.next(true);
  }

  private getTassonomiaBlock(tassonomie: any[]): any {
    let data: any[] = [];
    if (this.nodeService.taxonomies) {
      tassonomie.map((tassonomia: any) => {
        const dataTEmp = this.nodeService.taxonomies.find((el: any) => el.term_id === tassonomia.target_id.toString());
        if (dataTEmp) {
          data.push(dataTEmp);
        }
      });
    }
    return data;
  }

  private setDataFields(block: any): void {
    if (block.field_tassonomia_ruolo_persona.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_PERSONA.ROLE',
          value: block.field_tassonomia_ruolo_persona,
          isArray: true
        }
      ]
    }
    if (block.field_tassonomia_dottorati.length) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_PERSONA.DOCTORATE',
          value: block.field_tassonomia_dottorati,
          isArray: true
        }
      ]
    }
    if (this.node.field_tutor) {
      this.dataFieldTaxonomies = [
        ...this.dataFieldTaxonomies,
        {
          titolo: 'CONTENT_TYPES.PAGE_PERSONA.TUTOR',
          value: this.node.field_tutor,
          isArray: true
        }
      ]
    }
  }

  private setColumnContact(block: any): string {
    let data: any[] = [];
    if (block.field_indirizzo_email) {
      data.push('');
    }
    if (block.field_ricerca_in_corso) {
      data.push('');
    }
    if (block.field_periodo_di_ricerca_all_est) {
      data.push('');
    }
    switch (data.length) {
      case 1:
        return 'col-12';
      case 2: 
        return 'col-6';
      case 3: 
        return 'col-4';
      default:
        return 'col';
    }
  }

}
